import './App.css';
// Import CSS de Bootstrap
import 'bootstrap/dist/css/bootstrap.min.css';
// Import JS de Bootstrap (opcional, para componentes como dropdowns, modals, etc.)
import 'bootstrap/dist/js/bootstrap.bundle.min.js';
import { BrowserRouter, Routes, Route } from "react-router-dom"
import Inicio from './Inicio/Inicio';
import NavBar from './NavBar/NavBar';
import Servicios from './Servicios/Servicios';
import Intro from './Intro/Intro';
import Contacto from './Contacto/Contacto';
import Inspecciones from './Inspecciones/Inspecciones';
import Soluciones from './Soluciones/Soluciones';
import Seguridad from './Seguridad/Seguridad';
import Inicioinspecciones from './Inicioinspecciones/Inicioinspecciones';
import Inicioseguridad from './Inicioseguridad/Inicioseguridad';
import Iniciosolucioines from './Iniciosoluciones/Iniciosolucioines';
import Footer from './Footer/Footer';
import ScrollToSection from './ScrollToSection/ScrollToSection';
import AvisoLegal from './AvisoLegal/AvisoLegal';
import Privacidad from './Privacidad/Privacidad';
import Cookies from './Cookies/Cookies';
import Seo from './Seo/Seo';
import NotFound from './NotFound/NotFound';


function App() {
  

  return (
    <BrowserRouter>

        

      <Routes>

        <Route path="/" element={
          <>
            <Seo title="Drontalia | Inspecciones técnicas y servicios profesionales con drones" description="Drontalia ofrece servicios profesionales con drones: inspecciones técnicas de torres, plantas fotovoltaicas y aerogeneradores, soluciones geoespaciales, topografía, modelos 3D y seguridad medioambiental." path="/" />
            <ScrollToSection />
            <Inicio />
            <NavBar /> 
            <section id="inicio" className="section"><Intro /></section>
            <section id="servicios" className="section"><Servicios /></section>
            <section id="contacto" className="section"><Contacto /></section>
          </>
        } />
        
        <Route path="/inspecciones" element={
          <>
            <Seo title="Inspecciones técnicas con drones | Drontalia" description="Inspección con drones de torres de comunicación y alta tensión, plantas fotovoltaicas (termografía IEC TS 62446-3), aerogeneradores, techos y puentes, sin trabajos en altura." path="/inspecciones" />
            <Inicioinspecciones />
            <NavBar /> 
            <Inspecciones />
          </>
        } />

        <Route path="/soluciones" element={
          <>
            <Seo title="Soluciones geoespaciales con drones | Drontalia" description="Topografía y medición de terreno, cálculo de acopios, modelos 3D y seguimiento de obra con drones: datos geoespaciales precisos para tus proyectos." path="/soluciones" />
            <Iniciosolucioines />
            <NavBar /> 
            <Soluciones />
          </>
        } />

        <Route path="/seguridad" element={
          <>
            <Seo title="Seguridad y medioambiente con drones | Drontalia" description="Búsqueda y rescate de personas y apoyo en incendios forestales con drones equipados con cámara térmica: respuesta rápida y segura en emergencias." path="/seguridad" />
            <Inicioseguridad />
            <NavBar /> 
            <Seguridad />
          </>
        } />

        <Route path="/aviso-legal" element={<><Seo title="Aviso legal | Drontalia" description="Aviso legal del sitio web de Drontalia." path="/aviso-legal" /><AvisoLegal /></>} />
        <Route path="/politica-privacidad" element={<><Seo title="Política de privacidad | Drontalia" description="Política de privacidad del sitio web de Drontalia." path="/politica-privacidad" /><Privacidad /></>} />
        <Route path="/politica-cookies" element={<><Seo title="Política de cookies | Drontalia" description="Política de cookies del sitio web de Drontalia." path="/politica-cookies" /><Cookies /></>} />

        <Route path="*" element={
          <>
            <NavBar />
            <NotFound />
          </>
        } />

      </Routes>

      <Footer />  

    </BrowserRouter>


  );
}

export default App;
